export default __webpack_public_path__ + "static/media/react.21d464cb.png";